import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Textarea } from '@cdl/heartbeat-react';
import { trackComment } from '../../analytics/thunks/track-comment.thunk';
import { hasAutoLabelsAndNoDelineationsSelector } from '../../delineation/selectors/delineation.selectors';
import * as diagnosticActions from '../actions/diagnostic.actions';
import { commentSelector } from '../selectors/user-diagnostic.selectors';
import { needToAssessSelector } from '../../autoLabels/selectors/auto-labels.selectors';

interface Props {}
export const CommentEditor: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const comment = useSelector(commentSelector);
  const hasAutoLabelsAndNoDelineation = useSelector(
    hasAutoLabelsAndNoDelineationsSelector,
  );
  const needToAssess = useSelector(needToAssessSelector);
  const isCommentDisabled = hasAutoLabelsAndNoDelineation || needToAssess;
  const timer = useRef<NodeJS.Timeout | null>(null);
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (timer.current != null) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      dispatch(trackComment(event.target.value));
    }, 2000);
    dispatch(diagnosticActions.setComment({ comment: event.target.value }));
  };

  return (
    <Textarea
      onKeyDown={(e) => e.stopPropagation()}
      onKeyUp={(e) => e.stopPropagation()}
      value={comment}
      onChange={handleChange}
      resize='none'
      placeholder='Comment'
      isDisabled={isCommentDisabled}
      data-testid='comment-editor'
    />
  );
};
